'use client';
import { jsx } from 'react/jsx-runtime';
import { iconMap } from './constants.js';

const RenderIcon = ({ icon, ...props }) => {
    const Icon = iconMap[icon];
    return jsx(Icon, { ...props });
};

export { RenderIcon };
//# sourceMappingURL=RenderIcon.js.map
